import { Add, Edit, Delete } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useState } from "react";
import { createAxios } from "../../common/axios";
import { useDialog, useSimpleDialog, yesNoButtons } from "../../common/dialog";
import { createListStore } from "../../common/listStore";
import { listHeaderItems, renderListStore } from "../../common/listStoreUi";
import { PageTitle } from "../../layout/PageTitle";
import { CustomerNoteTypeDialog } from "./CustomerNoteTypeDialog";
import { CustomerNoteTypeDto } from "./types";


export function CustomerNoteTypeListPage() {
    const [useStore] = useState(() => createListStore<CustomerNoteTypeDto>({
        path: "settings/customerNoteTypes",
        itemsPerPage: 15,
        getId: p => p.id,
        listProps: [
            { column: "id", label: "Id", width: 120 },
            { column: "name", label: "Name", width: 200 },
            { column: "code", label: "Code", width: 120 },
            { column: "active", label: "Active", width: 120, type: "bool" },
            { column: "priority", label: "Priority", width: 120 },
        ],
    }));

    const customerNoteTypes = useStore(p => ({ selectedItem: p.selectedItem }));
    const simpleDialog = useSimpleDialog();
    async function deleteNoteTypes() {
        await simpleDialog.show("Customer note types", "Delete selected note type?", undefined, yesNoButtons(async () => {
            try {
                await createAxios().delete(`settings/customerNoteTypes/${customerNoteTypes?.selectedItem?.id}`);
            }
            finally {
                useStore.getState().fetch();
            }
        }));
    }
    const newDialog = useDialog(close => <CustomerNoteTypeDialog close={close} customerNoteTypes={null} useListStore={useStore}
        onChange={() => { useStore.getState().fetch(); }} />, "xs");
    const editDialog = useDialog(close => <CustomerNoteTypeDialog close={close} customerNoteTypes={customerNoteTypes.selectedItem!} useListStore={useStore}
        onChange={() => { useStore.getState().fetch(); }} />, "xs");
    return <>
        {newDialog.render()}
        {editDialog.render()}
        {simpleDialog.render()}
        <PageTitle title="Customer note types" />
        {renderListStore(useStore, {
            onDoubleClick: () => {
                editDialog.show();
            }, header: listHeaderItems([
                ["edit", () => <Button color="edit" disabled={customerNoteTypes.selectedItem == null} title="Edit" onClick={() => editDialog.show()}><Edit /></Button>],
                ["add", () => <Button color="add" title="Add" onClick={() => newDialog.show()}><Add /></Button>],
                ["remove", () => <Button color="delete" disabled={customerNoteTypes.selectedItem == null} title="Delete" onClick={deleteNoteTypes}><Delete /></Button>],
            ]),
        })}
    </>;
}
